import { Instance } from "mobx-state-tree";
import React from "react";
import { SurveyRuleModel } from "../../models/SurveyRuleModel";
import { Stack } from "@mui/material";
import { SurveyRuleConditionForm } from "../forms/SurveyRuleConditionForm";
import { SurveyRuleCardLayout } from "../../layouts/SurveyRuleCardLayout";
import { observer } from "mobx-react";
import { SurveyRuleRowActionButtons } from "../buttons/SurveyRuleRowActionButtons";
import { DividerComponent } from "../../../surveys/components/commonQuestionConfigurationDetailsComponents/DividerComponent";
import { useSpacing } from "@surya-digital/leo-reactjs-material-ui";
import { SurveyRuleActionForm } from "../forms/SurveyRuleActionForm";

interface SingleSurveyRuleCardProps {
  surveyRule: Instance<typeof SurveyRuleModel>;
}

export const SingleSurveyRuleCard: React.FC<SingleSurveyRuleCardProps> =
  observer(({ surveyRule }) => {
    const spacing = useSpacing();

    const firstConditionId = surveyRule.conditionOrder.at(0);
    if (!firstConditionId) {
      throw new Error("Survey rule condition list cannot be empty");
    }

    return (
      <SurveyRuleCardLayout surveyRuleId={surveyRule.ruleId}>
        <Stack direction="row" width="100%" paddingRight={spacing.spaceMD}>
          <Stack
            direction="row"
            width="100%"
            divider={<DividerComponent orientation="vertical" height="100%" />}
            gap={spacing.spaceXS}
          >
            <SurveyRuleConditionForm
              surveyRuleId={surveyRule.ruleId}
              surveyRuleCondition={surveyRule.getNonNullCondition(
                firstConditionId,
              )}
            />
            <SurveyRuleActionForm
              surveyRuleId={surveyRule.ruleId}
              surveyAction={surveyRule.action}
              surveyTarget={surveyRule.target}
            />
          </Stack>
          <SurveyRuleRowActionButtons ruleId={surveyRule.ruleId} />
        </Stack>
      </SurveyRuleCardLayout>
    );
  });
